import { get } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 系统相关API
export const systemApi = {
  /**
   * 获取语种列表
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  getLanguage: (game_id): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SYSTEM,
      API_CONFIG.ACTIONS.LANGUAGE,
      { game_id }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 获取扩展参数
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  getExtParams: (game_id): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SYSTEM,
      API_CONFIG.ACTIONS.GET_EXT_PARAMS,
      { game_id }
    );
    return get<ApiResponse>(url);
  },
};
